import { createMiddleware } from "@tanstack/react-start"
import { ensureStructuredLoggerConfigured } from "@apps/gwservice/logging"
import { ctx, runWithLogContext, sanitizeServerFunctionArgs } from "@mylaunch/utils/logs"

const getActionLabel = (
  serverFnMeta?: {
    id?: string
    name?: string
    filename?: string
  },
) => {
  if (serverFnMeta?.name) {
    const fileName = serverFnMeta.filename?.split("/").pop() ?? "unknown"
    const withoutExt = fileName.replace(/\.[^.]+$/, "")
    const fileLabel = withoutExt.endsWith(".functions")
      ? withoutExt.slice(0, -".functions".length)
      : withoutExt

    return `${fileLabel}:${serverFnMeta.name}`
  }

  return serverFnMeta?.id || "server-function:post:unknown"
}

export const loggingMiddleware = createMiddleware({ type: "function" }).server(async (options) => {
  ensureStructuredLoggerConfigured()
  const action = getActionLabel(options.serverFnMeta)
  const args = sanitizeServerFunctionArgs(options.data)
  return runWithLogContext(
    options.method,
    action,
    async () => {
      ctx({ args })
      return await options.next()
    },
    {
      action,
      args,
    },
  )
})
